import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/pages/Overview";

export default function Deals() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/deals");
        setRows(data);
      } catch {}
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="deals-page">
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-stone-500">Marketplace</div>
        <div className="font-display text-2xl font-bold text-stone-900">All My Deals</div>
      </div>
      <div className="rounded-xl bg-white border border-stone-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-xs uppercase tracking-widest font-bold">
            <tr>
              <th className="text-left p-3">Deal</th>
              <th className="text-left p-3">Commodity</th>
              <th className="text-left p-3">Role</th>
              <th className="text-left p-3">Counterparty</th>
              <th className="text-right p-3">Value</th>
              <th className="text-center p-3">Status</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {rows === null && Array.from({ length: 4 }).map((_, i) => (
              <tr key={i}><td colSpan={7} className="p-3"><div className="h-6 shimmer rounded" /></td></tr>
            ))}
            {rows && rows.length === 0 && (
              <tr><td colSpan={7} className="p-10 text-center text-stone-500">No deals yet.</td></tr>
            )}
            {rows && rows.map((d, i) => {
              const isBuyer = d.buyer_id === user.id;
              const cp = isBuyer ? d.seller_name : d.buyer_name;
              return (
                <motion.tr key={d.id} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }} className="border-t border-stone-100 hover:bg-stone-50" data-testid={`deal-row-${d.id}`}>
                  <td className="p-3 font-mono text-xs text-stone-500">#{d.id.slice(-8)}</td>
                  <td className="p-3 font-semibold text-stone-800">{d.commodity} · {d.quantity} {d.unit}</td>
                  <td className="p-3 text-xs">
                    {user.role === "admin" ? <span className="text-stone-500">Admin View</span> : (
                      <span className={`px-2 py-0.5 rounded ${isBuyer ? "bg-orange-100 text-orange-800" : "bg-emerald-100 text-emerald-800"} text-[10px] font-bold uppercase`}>
                        {isBuyer ? "Buyer" : "Seller"}
                      </span>
                    )}
                  </td>
                  <td className="p-3 text-stone-600">{cp}</td>
                  <td className="p-3 text-right font-mono font-semibold">₹{(d.total_value || 0).toLocaleString("en-IN")}</td>
                  <td className="p-3 text-center"><StatusBadge status={d.status} /></td>
                  <td className="p-3 text-right">
                    <Link to={`/app/deals/${d.id}`} className="text-xs font-bold text-emerald-800 hover:text-orange-600" data-testid={`open-deal-${d.id}`}>Open →</Link>
                  </td>
                </motion.tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
